import React from 'react';
import { bool } from 'prop-types';
import { Skeleton, SkeletonContent, SkeletonBlock, SkeletonLine } from '@one-thd/sui-atomic-components';

export const CompatibleAccessoriesLoader = (hideRequiredText) => {
  return (
    <div>
      {!hideRequiredText && (
        <Skeleton grow>
          <SkeletonLine variant="single" />
        </Skeleton>
      )}
      <Skeleton disablePadding="y" orientation="horizontal" grow>
        <SkeletonContent density="loose" disablePadding="x" initialSize="full">
          <SkeletonBlock aspect="wide" />
        </SkeletonContent>
        <SkeletonContent density="loose" disablePadding="x" initialSize="full">
          <SkeletonLine numberOfLines={3} />
        </SkeletonContent>
      </Skeleton>
    </div>
  );
};

CompatibleAccessoriesLoader.propTypes = {
  hideRequiredText: bool
};

CompatibleAccessoriesLoader.defaultProps = {
  hideRequiredText: false
};
